module.exports = window["vue"];